import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "../../Components/Bookings/Bookings.module.css";
import upArrow from "../../Images/up.png";
import offerImg from "../../Images/offer.png";
import BillLine from "../../Components/Bookings/BillLine";
import downArrow from "../../Images/down.png";
import { useSelector, useDispatch } from "react-redux";
import { cancelService, getReservationService } from "../../redux/Slices/reservation/thunk";
import { Button, Modal, Spinner } from "react-bootstrap";
import Logo from "../../Images/Logo.png";
import { useNavigate } from "react-router-dom";
import notify from "../Utilities/notify";
import image1 from "../../Images/noimage.jpeg";

export default function BookService({ toggleShow, setServicesLength }) {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const isArabic = currentLanguage === "ar";
  const navigate = useNavigate();
  const [openBillIndex, setOpenBillIndex] = useState(null); 
  const [showCancelModel, setShowCancelModel] = useState(false);
  const [cancelNotes, setCancelNotes] = useState("");
  const [reservationNum, setReservationNum] = useState("");
  const [reservationNumForCancel, setReservationNumForCancel] = useState("");
  const [serviceForCancel, setServiceForCancel] = useState("");
  const { ReservationServices, loading } = useSelector(
    (state) => state.reservationSlice
  );
  const { settings } = useSelector((state) => state.usersSlice);
  console.log("ReservationServices", ReservationServices);
  console.log("settings", settings);
  const user = JSON.parse(localStorage.getItem("user"));

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getReservationService({ id: user?.cln_key }));
  }, []);

    const parseDate = (dateStr) => {
      const [year, month, day] = dateStr.split('/'); 
      return new Date(year, month - 1, day); 
    };
  
    const isPastDate = (dateStr) => {
      const serviceDate = parseDate(dateStr);
      const currentDate = new Date();
      currentDate.setHours(currentDate.getHours() + Number(settings?.expir_dat_for_edit?.trim()));
      // console.log("currentDate48",currentDate)
      currentDate.setHours(0);
      currentDate.setMinutes(0);
      currentDate.setSeconds(0);
      currentDate.setMilliseconds(0);
      console.log("currentDate48",currentDate)
      return serviceDate < currentDate; 
    };
    const isPastDateForCancel = (dateStr) => {
      const serviceDate = parseDate(dateStr);
      const currentDate = new Date();
      currentDate.setHours(currentDate.getHours() + Number(settings?.cancel_service?.trim()));
      // console.log("currentDate48",currentDate)
      currentDate.setHours(0);
      currentDate.setMinutes(0);
      currentDate.setSeconds(0);
      currentDate.setMilliseconds(0);
      console.log("currentDateForCancel",currentDate)
      return serviceDate < currentDate; 
    };

  const toggleBill = (index) => {
    setOpenBillIndex((prevIndex) => (prevIndex === index ? null : index)); // Toggle between null (closed) and selected index
  };


  const createInvoiceHTML = (reservation, packageServicesData) => {
    const direction = isArabic ? "rtl" : "ltr";
    const lang = isArabic ? "ar" : "en";

    return `
          <!DOCTYPE html>
        <html lang="${lang}" dir="${direction}">
            <head>
              <meta charset="utf-8">
              <title>Invoice</title>
              <style>
                body {
                  font-family: Cairo;
                  margin: 20px;
                  direction: ${direction};
                  text-align: ${isArabic ? "right" : "left"};
                  font-size: 13px;

                }
                .invoice-container {
                   max-width: 800px;
                   margin: auto;
                   padding: 20px;
                   text-align: center; /* Centers text inside */
                   position: relative;
                   }

                .clientContainer {
                   max-width: 800px;
                   margin: auto;
                   padding: 10px;
                   padding-top: 20px;
                   text-align: center; /* Centers text inside */
                   position: relative;
                   }
                .invoice-title {
                position: absolute;
                top: -25px; /* Adjust this to fit inside the border */
                left: ${isArabic ? "" : "20%"};
                right: ${isArabic ? "-30px" : ""};
                transform: translateX(-50%);
                background: white;
                padding: 0 10px;
                font-size: 13px;
                font-weight: bold;
                border: 1px solid #000;
                background-color: #d1d1d1;
                }

              .header {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                font-size: 12px;

              }

              .logo-container {
                display: flex;
                justify-content: center;
                position: relative;
                top: -10px; 
              }

              .logo-container img {
                height: 120px;
                width: auto;
              }
                .header h2 {
                  margin: 0 0 10px;
                   text-align: ${isArabic ? "right" : "left"};
                   font-size: 12px;

                }
                .header p {
                  margin: 4px 0;
                   text-align: ${isArabic ? "right" : "left"};
                   font-size: 12px;

                }
                table {
                  width: 100%;
                  border-collapse: collapse;
                  margin-bottom: 20px;
                }
                table, th, td {
                  border: 1px solid #000;
                }
                  td{
                  font-size: 12px;
                  }
                th, td {
                  padding: 8px;
                  text-align: left;
                  text-align: ${isArabic ? "right" : "left"};
                }
                th {
                  background-color: #d1d1d1;
                  font-size: 13px;

                }
                .section-title {
                  font-size: 13px;
                  background-color: #d1d1d1;
                  padding: 10px;
                  font-weight: bold;
                  margin-bottom: 10px;
                }
              </style>
            </head>
            <body>
              <div class="invoice-container" >
             <div class="clientContainer" style="display: flex; align-items: center; justify-content: space-between;  border: 1px solid #000;">
              <!-- Title Section -->
              <h2 class="invoice-title">${t("client_data")}</h2>

              <!-- Header Section -->
              <div class="header">
                <p>${t("Client ID")} : ${reservation?.serviceHeader?.ith_custL4}</p>
                <p>${t("Client Name")} : ${user?.cln_username}</p>
                <p>${t("email")}: ${user?.cln_email}</p>
                <p>${t("phoneNumber")} : ${user?.cln_mobl}</p>
                <p>${t("bookDate")} : ${reservation?.serviceHeader?.ith_dat}</p>
                <p>${t("branch")} : ${ isArabic ? reservation?.serviceHeader?.branchNameArabic?.trim() : reservation?.serviceHeader?.branchNameEngilsh?.trim() }</p>
              </div>

              <!-- Logo Section -->
              <div class="logo-container">
                <img src="${Logo}" alt="Logo">
              </div>
            </div>
                  <br />

                  <!-- Service Details Table -->
          <div class="section">
            ${
              reservation?.serviceDetails &&
              reservation.serviceDetails.length > 0
                ? `
                  <table>
                   <tr>
                    <th colspan="5" style="text-align: center; height:35px;" >${t(
                      "Service Details"
                    )}</th>
                    </tr>
                    <tr>
                      <td style="text-align: center; ">${t("Service Name")}</td>
                      <td style="text-align: center; ">${t("date")}</td>
                      <td style="text-align: center; ">${t("serviceProvider")}</td>
                      <td style="text-align: center; ">${t("time")}</td>
                    </tr>
                    ${reservation.serviceDetails
                      .map(
                        (service) => `
                      <tr>
                        <td style="text-align: center; ">${
                          isArabic
                            ? service?.itd_itm_nam?.trim()
                            : service?.itd_itm_enm?.trim()
                        }</td>
                        <td style="text-align: center; ">${
                          service?.itd_dat
                        }</td>
                        <td style="text-align: center; ">${
                          isArabic
                            ? service?.itd_emp_nam
                            : service?.itd_emp_enam
                        }</td>
                        <td style="text-align: center; ">${
                          service?.sevrce_time
                        }</td>
                      </tr>
                    `
                      )
                      .join("")}
                  </table>
                `
                : `<p>${t("No services available")}</p>`
            }
          </div>
    


                <!-- Invoice Details Table -->
                <div class="section">
                  <table>
                   <tr>
                    <th colspan="5" style="text-align: center; height:35px;" >${t(
                      "Invoice Details"
                    )}</th>
                    </tr>
                    <tr> 
                    <tr>
                      <td  style="text-align: center; width:50%; ">${t("paymentType")}</td>
                      <td style="text-align: center; width:50%; ">${
                        reservation?.serviceHeader?.ith_payM == 1
                          ? t("cash")
                          : t("online")
                      }</td>
                    </tr>
                    <tr>
                      <td style="text-align: center; width:50%; ">${t(
                        "totalIncludingTax"
                      )}</td>
                      <td style="text-align: center; width:50%; ">${(
                        Number(reservation?.serviceHeader?.ith_totalamount) +
                        Number(reservation?.serviceHeader?.ith_dscntV)
                      ).toFixed(2)} ${t("rs")}</td>
                    </tr>
                    <tr>
                      <td style="text-align: center; width:50%; ">${t(
                        "Added Value Tax"
                      )}</td>
                      <td style="text-align: center; width:50%; ">${Number(
                        reservation?.serviceHeader?.ith_TXTS
                      ).toFixed(2)} ${t("rs")}</td>
                    </tr>
                    <tr>
                      <td style="text-align: center; width:50%; ">${t(
                        "Discount Coupon"
                      )}</td>
                      <td style="text-align: center; width:50%; ">${Number(
                        reservation?.serviceHeader?.ith_dscntV
                      ).toFixed(2)} ${t("rs")}</td>
                    </tr>
                    <tr>
                      <td style="text-align: center; width:50%; ">${t("Loyal Points")}</td>
                      <td style="text-align: center; width:50%; ">${Number(
                        reservation?.serviceHeader?.ith_PayMVal2
                      ).toFixed(2)} ${t("rs")}</td>
                    </tr>
                    <tr>
                      <th style="text-align: center; width:50%; ">${t("Total")}</th>
                      <th style="text-align: center; width:50%; ">${(
                        Number(
                          reservation?.serviceHeader?.ith_totalamount
                        )?.toFixed(2) -
                        Number(reservation?.serviceHeader?.ith_PayMVal2)
                      ).toFixed(2)} ${t("rs")}</th>
                    </tr>
                  </table>
                </div>
                
                
    </div>
            </body>
          </html>
        `;
  };

  const handlePrint = async (reservation) => {
    try {
      const invoiceHTML = createInvoiceHTML(reservation);

      const printWindow = window.open("", "", "width=800,height=600");
      printWindow.document.write(invoiceHTML);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
    } catch (error) {
      console.error("Error fetching package services:", error);
    }
  };


    const handleEditClick = (service, index) => {
    // return  console.log("reservationNum",reservationNum)
      if (isPastDate(service.itd_dat)) {
       return notify(t("services_expired"), "error");
      } 
        navigate("/serviceproviders", {
          state: {
            isEdit: true,
            emp_num: service?.emp_num,
            itd_dat: service?.itd_dat,
            servicesId: service?.itd_itmsrl,
            servicesId2: service?.itd_srl,
            reservationNum:reservationNum
          },
        });
      
    };

    const handleCancelClick = (service, index, reservation) => {
      if (isPastDateForCancel(service.itd_dat)) {
        return notify(t("servicesCancelExpired"), "error");
      } 
      setShowCancelModel(true)
    };
    
    const CancelSubmit = async () =>{
      
      
      let data={
        status : 2,
        serviceSerial : serviceForCancel?.itd_srl,
        notes : cancelNotes,
    }
    // return console.log("data",data, "reservationNumForCancel", reservationNumForCancel)
    await dispatch(cancelService({
      id:reservationNumForCancel,
      data:data
    }))

    await dispatch(getReservationService({ id: user?.cln_key }));
    }

    if(ReservationServices){
    setServicesLength(ReservationServices?.length)
  }

  return (
    <>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Spinner
            animation="border"
            role="status"
            style={{ width: "100px", height: "100px" }}
          />
        </div>
      ) : (
        <div>
          {ReservationServices?.length > 0 ? (
            <div>
              {ReservationServices.map((reservation, index) => (
                <div key={index} className={`mx-auto ${styles.box} my-3 bg-white `} >
                  <div
                    className={`d-flex justify-content-between p-2 flex-wrap`}
                  >
                    <div style={{width:"100px"}} >{reservation.serviceHeader.ith_num}</div>
                    <div style={{width:"100px", display:"flex", justifyContent:"center"}} >
                      <img
                        id="billImg"
                        onClick={() => toggleBill(index)} // Pass the index to toggleBill
                        src={openBillIndex === index ? downArrow : upArrow} // Change arrow based on open/close state
                        alt=""
                      />
                    </div>
                    <div style={{width:"100px"}} >{reservation.serviceHeader.ith_dat}</div>
                  </div>

                  {reservation?.serviceDetails?.map((service, serviceIndex) => (
                    <div
                      key={serviceIndex}
                      className={`${styles.offerBox} m-2 bg-liteGray `}
                      style={{ opacity: service?.itd_free === 0 ? 0.5 : 1 }} // Apply opacity

                    >
                      <div className="d-flex justify-content-between flex-wrap m-2">
                        <div className={styles.imageBox}>

                          <img 
                          src={(service?.itd_itm_IMG && service?.itd_itm_IMG?.trim() !="" ) ? `https://reservation.ladycaresa.com/public/uploads${service?.itd_itm_IMG}` : image1} 
                          alt="" style={{width:'50px', border:"1px solid #B49345", borderRadius:"8px"}}/>
                        </div>
                        <div className={`my-auto ${styles.serviceTitle2}`}>
                          {isArabic
                            ? service?.itd_itm_nam?.trim()
                            : service?.itd_itm_enm?.trim()}
                        </div>
                 


                        {
                          //"openBillIndex" Only show the bill for the selected reservation
                          <div id="bill" className="w-100 bg-liteGray">

                            {service?.itd_statt == 2 && (
                          <div
                          className="d-flex justify-content-center align-items-center text-white p-3 my-3 rounded shadow-lg"
                          style={{
                            background: "linear-gradient(135deg, #4a4a4a 0%, #1f1f1f 100%)", // Gradient background for a sleek look
                            fontWeight: "bold",
                            fontSize: "16px",
                            letterSpacing: "0.8px",
                            borderLeft: isArabic ? "0px solid red" : "6px solid red", 
                            borderRight: isArabic ? "6px solid red" : "0px solid red", 
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.84) ",
                            textTransform: "uppercase", 
                            width: "100%",
                            textAlign: "center",
                            padding: "12px",
                            borderRadius: "8px"
                          }}
                        >
                          <i className="fas fa-exclamation-circle me-2"></i> {/* Icon for better UX */}
                          {t("serviceCanceled")}
                        </div>
                        
                          
                            )}

                         {service?.itd_statt != 2 &&    <div
                              className={`d-flex my-3 flex-column ${styles.serviceClass}`}
                             
                            >
                              <BillLine
                                text1={`${t("serviceProvider")} : ${
                                  currentLanguage == "ar"
                                    ? service?.itd_emp_nam
                                    : service?.itd_emp_enam
                                }`}
                                text2={`${t("date")}: ${service.itd_dat}`}
                                styles={styles}
                                myClass={"gap-3 justify-content-between"}
                              />
                              <BillLine
                                text1={`${t("branch")} : ${
                                  currentLanguage == "ar"
                                    ? reservation?.serviceHeader?.branchNameArabic?.trim()
                                    : reservation?.serviceHeader?.branchNameEngilsh?.trim()
                                }`}
                                text2={`${t("time")}: ${service?.sevrce_time}`}
                                styles={styles}
                                myClass={"gap-3 justify-content-between"}
                              />
                            </div>}
                          </div>
                        }
                      </div>
                     { openBillIndex === index &&  service?.itd_statt != 2 &&  <div className="d-flex justify-content-between mb-2" style={{gap:"10px"}}>
                          <button className={styles.button} 
                                    style={{
                                            width:"50%" , 
                                            background: isPastDate(service.itd_dat) ? 'gray' : '' ,
                                            cursor: isPastDate(service.itd_dat) ? 'not-allowed' : '' 
                                            }} 
                                    onClick={() => {
                                    setReservationNum(reservation?.serviceHeader?.ith_num)
                                    if(reservation?.serviceHeader?.ith_num == reservationNum){
                                      handleEditClick(service, index)}
                                    }
                                    } >{t("Edit")}</button>

                          <button className={styles.button}
                                  style={{
                                    width:"50%" , 
                                    background: isPastDateForCancel(service.itd_dat) ? 'gray' : '' ,
                                    cursor: isPastDateForCancel(service.itd_dat) ? 'not-allowed' : '' 
                                    }}
                                    onClick={() => {
                                      setReservationNumForCancel(reservation?.serviceHeader?.ith_num)
                                      setServiceForCancel(service)
                                      handleCancelClick(service, index)
                                    }} 
                          >
                            {t("Cancel")}
                          </button>
                      </div>}
                    </div>
                  ))}

                  {openBillIndex === index && ( // Check if the current reservation's bill should be shown
                    <div id="bill" className={`${styles.billBox} m-2 bg-liteGray`}>
                      <div className="m-2">
                      <div className={`${styles.titleBill}`}>
                          {t("Bill")}{" "}
                        </div>

                        <BillLine
                          text1={t("paymentType")}
                          text2={
                            reservation?.serviceHeader?.ith_payM == 1
                              ? t("cash")
                              : t("online")
                          }
                          styles={styles}
                          myClass="my-3 justify-content-between"
                        />
                        <BillLine
                          text1={t("totalIncludingTax")}
                          text2={`${(
                            Number(
                              reservation?.serviceHeader?.ith_totalamount
                            ) + Number(reservation?.serviceHeader?.ith_dscntV)
                          )?.toFixed(2)} ${t("rs")}`}
                          styles={styles}
                          myClass="my-3 justify-content-between"
                        />
                        <BillLine
                          text1={t("Added Value Tax")}
                          text2={`${Number(
                            reservation?.serviceHeader?.ith_TXTS
                          )?.toFixed(2)} ${t("rs")}`}
                          styles={styles}
                          myClass="my-3 justify-content-between"
                        />
                        <BillLine
                          text1={t("Discount Coupon")}
                          text2={`${Number(
                            reservation?.serviceHeader?.ith_dscntV
                          )?.toFixed(2)} ${t("rs")}`}
                          styles={styles}
                          myClass="my-3 justify-content-between"
                        />
                        <BillLine
                          text1={t("Loyal Points")}
                          text2={`${Number(
                            reservation?.serviceHeader?.ith_PayMVal2
                          )?.toFixed(2)} ${t("rs")}`}
                          styles={styles}
                          myClass="my-3 justify-content-between"
                        />
                        <BillLine
                          text1={t("Total")}
                          text2={`${(
                            Number(
                              reservation?.serviceHeader?.ith_totalamount
                            )?.toFixed(2) -
                            Number(reservation?.serviceHeader?.ith_PayMVal2)
                          ).toFixed(2)} ${t("rs")}`}
                          styles={styles}
                          myClass="my-3 justify-content-between"
                        />
                        <div className="d-flex justify-content-between mt-5 flex-wrap">
                       
                          <button
                            className={styles.button}
                            style={{width:"100%"}}
                            onClick={() => handlePrint(reservation)}
                          >
                            {t("Print")}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div
              className="text-center fw-bold"
              style={{
                fontSize: "20px",
                color: "#555",
                margin: "10px",
                textTransform: "capitalize",
              }}
            >
              {t("noBookedServices")}
            </div>
          )}
        </div>
      )}

<Modal
  show={showCancelModel}
  onHide={() => setShowCancelModel(false)} 
  backdrop="static" 
  dialogClassName="custom-modal"
>
  <h2
    style={{
      textAlign: "center",
      marginBottom: "20px",
      marginTop: "10px",
    }}
  >
    {t("confirmServiceCancel")}
  </h2>

  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "15px" }}>
    <label htmlFor="cancelNotes">{t("addNotes")}</label>
    <input
      type="text"
      id="cancelNotes"
      value={cancelNotes}
      onChange={(e) => setCancelNotes(e.target.value)}
      placeholder={t("enterNotes")}
      style={{ 
        width: "80%", 
        padding: "8px", 
        borderRadius: "5px", 
        border: "1px solid #ccc", 
        marginTop: "5px",
        outline: "none"  // Removes focus outline
      }}    />
  </div>

  <div className="modal-actions" style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
    
    <Button
      onClick={() => {
        CancelSubmit()
        setShowCancelModel(false); 
      }}
      variant="danger"
    >
      {t('confirm')}
    </Button>

    <Button
      onClick={() => setShowCancelModel(false)} 
      variant="secondary"
    >
      {t('Cancel')}
    </Button>
  </div>
</Modal>
    </>
  );
}
